import React from "react";
import { RefreshCw } from "lucide-react";

const Loading = () => {
  return (
    <div className="h-full w-full flex flex-col items-center justify-center p-10 text-gray-400">
      <RefreshCw className="w-8 h-8 animate-spin mb-2 text-orange-500" />
      <p className="text-xs font-bold uppercase tracking-widest">Cargando...</p>
    </div>
  );
};

export default Loading;
